import { call, put, takeLatest } from "redux-saga/effects";
import { httpUploadBulkQuestions } from "../../../services/questions";
import {
  createBulkQuestionStart,
  createBulkQuestionSuccess,
  createBulkQuestionFailure,
} from "../reducer";
import { successNotifier } from "../../../utils/helpers";
import { networkErrorHandler } from "../../../utils/errorHandlers";

export function* bulkQuestionsUpload({ payload }) {
  const { data, callback } = payload;
  const response = yield call(httpUploadBulkQuestions, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(createBulkQuestionSuccess(raw));
    successNotifier(`${raw?.length} question(s) added successfully`);
    if (callback) {
      callback();
    }
  } else {
    yield put(createBulkQuestionFailure(message || raw));
    networkErrorHandler(response.statusCode, message || raw);
  }
}

export default function* onBulkQuestionsUpload() {
  yield takeLatest(createBulkQuestionStart.type, bulkQuestionsUpload);
}
